export type InvoiceMobileAction = {
  action: string;
  [key: string]: any;
};

export const getInvoiceEmbedMode = () => {
  if (typeof window === 'undefined') return null;

  return new URLSearchParams(window.location.search).get('embed');
};

export const isInvoiceMobileEmbed = () => {
  const mode = getInvoiceEmbedMode();

  return (
    mode === 'invoice-left' ||
    mode === 'invoice-right'
  );
};

export const sendInvoiceMobileAction = (
  message: InvoiceMobileAction,
): boolean => {
  if (
    typeof window === 'undefined' ||
    !isInvoiceMobileEmbed()
  ) {
    return false;
  }

  const bridge = (window as any).ReactNativeWebView;

  if (!bridge?.postMessage) {
    return false;
  }

  bridge.postMessage(JSON.stringify(message));

  return true;
};
